/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { SamlSettings } from '@modules/cloud-api/v1/types'
import withRouter from '@modules/routing/withRouter'

import { createSamlSecurityRealmRequest } from '@/apps/adminconsole/reducers/registry'

import { createSamlSecurityRealm } from '../../../../../actions'

import AddSamlProvider from './AddSamlProvider'

const mapStateToProps = (
  state,
  {
    router: {
      params: { regionId },
    },
  },
) => ({
  regionId,
  submitRequest: createSamlSecurityRealmRequest(state, regionId),
})

const mapDispatchToProps = (
  dispatch,
  {
    router: {
      params: { regionId },
    },
  },
) => ({
  onSubmit: (payload: SamlSettings) => dispatch(createSamlSecurityRealm(regionId, payload)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddSamlProvider))
